import React, { lazy, Suspense } from "react";
import 'grapesjs/dist/css/grapes.min.css';
import "react-toastify/dist/ReactToastify.css";
import 'react-calendar/dist/Calendar.css';
import "./App.scss";
import { Route, Routes } from "react-router-dom";
import { PageNotFound, Signup } from "./components";
import { Main, Dashboard, Help, Settings, ABTest, ProductABTest } from "./layout";
import LoadingAnimationFullScreen from "./components/Loading/LoadingAnimationFullScreen";
import { Brevo, Klaviyo, MailChimp, Zoho, Hubspot, Wix, Email, WhatsApp } from "./layout/Integration/components";
import Admin from "./components/Admin";
import AdminLogin from "./components/AdminLogin/AdminLogin";
// import Constants from './layout/CampaignFlows/UnlayerNudge/UnlayerNudge/editor';
// import DesignEdit from './layout/CampaignFlows/UnlayerNudge/UnlayerNudge/dashboard/DesignEdits';
// import PredefinednudgesEditor from "./layout/CampaignFlows/UnlayerNudge/UnlayerNudge/predefinedNudgeEditor.js";
import DetailedHeatmapTable from "./layout/HeatmapXUserSegment/components/HeatmapResult/DetailedHeatmapTable/";
import SessionReplayDashboard from "./layout/SessionReplay/dashboard.jsx";
import SessionReplayPlayer from "./layout/SessionReplay/player.jsx";
import ABTestCreateConfig from "./layout/ABTest/ElementABTest/components/index.js";
import ABTestDashboard from "./layout/ABTest/ABTestDashboard/index.jsx";
import ABTestView from "./layout/ABTest/abTestDataView/route.jsx";
// import ABTestView from "./layout/ABTest/abtestView/route.jsx";

const ContentPerformance = lazy(() =>
  import("./layout/ContentPerformance/ContentPerformance")
);
const TrafficSources = lazy(() =>
  import("./layout/TrafficSources/TrafficSources")
);
const MarketingPerformance = lazy(() =>
  import("./layout/MarketingPerformance")
);
const PersonasPrediction = lazy(() =>
  import("./layout/Persona")
);
const CohortInsights = lazy(() =>
  import("./layout/CohortInsights")
);
const FunnelLeakage = lazy(() =>
  import("./layout/FunnelLeakage")
);
const EmailCustomers = lazy(() =>
  import("./layout/EmailCustomers/EmailCustomers")
);
const FirstLastTouch = lazy(() =>
  import("./layout/FirstLastTouch/FirstLastTouch")
);

const GoogleAnalytics = lazy(() =>
  import("./layout/GoogleAnalytics/GoogleAnalytics")
);

const ChangePassword = lazy(() =>
  import("./layout/ChangePassword/ChangePassword")
);
const CustomizedNudge = lazy(() =>
  import("./layout/CustomizedNudge/CustomizedNudge")
);
const DesignEditor = lazy(() =>
  import("./layout/DesignEditor")
);
const ChatBot = lazy(() =>
  import('./layout/Chatbot')
)
const ChatBotSettings = lazy(() =>
  import('./layout/Chatbot/components/ChatbotSettings/')
)
const ChatBotAnalytics = lazy(() =>
  import('./layout/Chatbot/components/ChatbotAnalytics')
)
const DataSource = lazy(() =>
  import('./layout/DataSource')
)
const Integraion = lazy(() =>
  import('./layout/Integration')
)
const Results = lazy(() =>
  import('./layout/Results/Results')
)
const CouponWisePerformance = lazy(() =>
  import('./layout/Persona/components/NudgeBasedPerformance')
)
const Landingpage = lazy(() =>
  import('./layout/LandingPageOptimizer/Landingpage')
)

const VisualEditors = lazy(() =>
  import('./layout/LandingPageOptimizer/VisualEditors')
)

const Goals = lazy(() =>
  import('./layout/LandingPageOptimizer')
)

const Finalize = lazy(() =>
  import('./layout/LandingPageOptimizer/Finalize')
)
// const Flows = lazy(() =>
//   import('./layout/CampaignFlows/Flows')
// )

// const Create = lazy(() =>
//   import('./layout/CampaignFlows/Create')
// );

// const Editor = lazy(() =>
//   import('./layout/CampaignFlows/editor')
// )
const LandintDashboard = lazy(() =>
  import('./layout/LandingPageOptimizer/Dashboard.jsx')
)


// const NewCustomizedNudge = lazy(() =>
//   import("./layout/CampaignFlows/NewCustomizedNudge/NewCustomizedNudge/NewCustomizedNudge")
// );

const BookingProductListing = lazy(() => 
  import("./layout/BookingPlatform/components/ProductListing")
);
const BookingPlatformSetting = lazy(() => 
  import("./layout/BookingPlatform/components/PlatformSettings")
);
const BookingPlatfromAnalytics = lazy(() => 
  import("./layout/BookingPlatform/components/BookingAnalytics")
);
const BookingPlatformUserDetails = lazy(() => 
  import("./layout/BookingPlatform/components/UserBookingCalendar")
);
const BookingPlatformProductItem = lazy(() => 
  import("./layout/BookingPlatform/components/ProductListing/ProductItem.jsx")
);
const BookingPlatformCreateProduct = lazy(() => 
  import("./layout/BookingPlatform/components/ProductListing/AddProductForm.jsx")
);

const HeatMapResult = lazy(() => 
  import("./layout/HeatmapXUserSegment/components/HeatmapResult")
);
const AdsOfflineConversion = lazy(() =>
  import("./layout/AdsOfflineConversion")
);

const BlogUpdate = lazy(() =>
  import("./layout/MarketingPerformance/components/BlogUpdate")
);

const App = () => {
  return (
    <>
      <Suspense fallback={<LoadingAnimationFullScreen />}>
        <Routes>
          <Route path="start-free-trial" element={<Signup />} />
          <Route path="admin" element={<Admin />} />
          <Route path="admin/login" element={<React.Suspense fallback={<div>Loading...</div>}><AdminLogin /></React.Suspense>} />
          <Route path="/" element={<Dashboard />}>
            <Route path="" element={<Main />} />
            <Route path="help" element={<Help />} />
            <Route path="settings" element={<Settings />} />
            <Route path="content" element={<ContentPerformance />} />
            <Route path="traffic" element={<TrafficSources />} />
            <Route path="marketing" element={<MarketingPerformance />} />
            <Route path="blog-update" element={<BlogUpdate />} />
            <Route path="ab-test" element={<ABTest />} />
            <Route path="product-ab-test" element={<ProductABTest />} />
            <Route path="element-ab-test" element={<ABTestDashboard />} />
            {/* <Route path="element-ab-test" element={< />} /> */}
            <Route path="create-element-test" element={<ABTestCreateConfig />} />
            <Route path="/abtest-view/:testId" element={<ABTestView />} />

            {/* <Route path="abtest-view" element={<ABTestView />} /> */}
            <Route path="personas">
              <Route index element={<PersonasPrediction />} />
              <Route path="performance" element={<CouponWisePerformance />} />

            </Route>
            <Route path="cohort-insight" element={<CohortInsights />} />
            <Route path="ads-leakage" element={<FunnelLeakage />} />
            <Route path="offline-emails" element={<EmailCustomers />} />
            <Route path="first-last-touch" element={<FirstLastTouch />} />
            <Route path="Google-Analytics" element={<GoogleAnalytics />} />
            <Route path="landing-optimization" element={<Landingpage />} />
            <Route path="Google-Analytics" element={<GoogleAnalytics />} />
            <Route path="Ads-Offline-Conversion" element={<AdsOfflineConversion />} />
            {/* <Route path="flows"> */}
            {/* <Route index element={<Flows/>} /> */}
            {/* <Route path="create" element={<Create />} />
            <Route path="editor/:Category/:campainID" element={<Editor />} />
            <Route path="new-custom-nudge/editor/:endpoint1/:endpoint2" element={<Constants />} />     
            <Route path="new-custom-nudge/editor/predefinednudges/:endpoint2" element={<PredefinednudgesEditor />} />    
            <Route path={`new-custom-nudge/design/new/:endpoint`} element={<DesignEdit />} /> 
            <Route path="new-custom-nudge" element={<NewCustomizedNudge />} />
            </Route>             */}
            <Route path="editor" element={<VisualEditors />} />
            <Route path="goals" element={<Goals />} />
            <Route path="landing-page-result" element={<LandintDashboard />} />
            <Route path="finalize" element={<Finalize />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="custom-nudge" element={<CustomizedNudge />} />
            <Route path="bandit-test" element={<DesignEditor />} />
            <Route path="insights" element={<Results />} />
            <Route path="chatbot" element={<ChatBot />} />
            <Route path="chatbot-settings" element={<ChatBotSettings />} />
            <Route path="chatbot-analytics" element={<ChatBotAnalytics />} />
            {/* <Route path="heatmap" element={<HeatmapXUserSegment />} /> */}
            <Route path="heatmap" element={<DetailedHeatmapTable />} />
            <Route path="heatmap/view/:id" element={<HeatMapResult />} />
            <Route path="data-source" element={<DataSource />} />
            <Route path="session-replay" element={<SessionReplayDashboard />} />
            <Route path="session-player" element={<SessionReplayPlayer />} />
            <Route path="booking">
              {/* <Route index element={<Integraion />} /> */}
              <Route path="user-details" element={<BookingPlatformUserDetails />} />
              <Route path="platform-settings" element={<BookingPlatformSetting />} />
              <Route path="products" element={<BookingProductListing />} />
              <Route path="products/create" element={<BookingPlatformCreateProduct />} />
              <Route path="products/:id" element={<BookingPlatformProductItem />} />
              <Route path="stats" element={<BookingPlatfromAnalytics />} />
            </Route>
            <Route path="integration">
              <Route index element={<Integraion />} />
              <Route path="brevo" element={<Brevo />} />
              <Route path="whatsapp" element={<WhatsApp />} />
              <Route path="mailchimp" element={<MailChimp />} />
              <Route path="klaviyo" element={<Klaviyo />} />
              <Route path="email" element={<Email />} />
              <Route path="hubspot" element={<Hubspot />} />
              <Route path="wix" element={<Wix />} />
              <Route path="zoho" element={<Zoho />} />
            </Route>
          </Route>
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;